import { REDUCE_CANCELLATION } from '../../constants/actions/policy';

export function reduceCancellation(payload) {
    return {
        type: REDUCE_CANCELLATION,
        payload,
    };
}
